// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__165lq","title":"styles_title__9C5S-"};